<template>
  <div class="display-data _margin-bottom-20">
    {{ map[paymentId] }}
    <uiv-btn type="link" size="xs" @click="$emit('onEdit')">Change</uiv-btn>
  </div>
</template>

<script>
export default {
  name: 'PaymentTypeDisplay',
  data() {
    return {
      map: {
        monthlyDirectDebit: 'Monthly Direct Debit',
        quarterlyDirectDebit: 'Quarterly Direct Debit',
        cashOrCheque: 'Cash & Cheque',
        prePaymentMeter: 'Prepayment'
      }
    }
  },
  props: {
    paymentId: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss"></style>
